(() => {
  const builders = document.querySelectorAll(
    '[data-titan-rubber-glove-builder]'
  );

  if (!builders.length) return;

  builders.forEach(initTitanRubberGloveBuilder);

  function initTitanRubberGloveBuilder(root) {
    const dataScript = root.querySelector('[data-titan-rgb-data]');

    if (!dataScript) return;

    let config;

    try {
      config = JSON.parse(dataScript.textContent);
    } catch (error) {
      console.error('Titan Rubber Glove Builder data error:', error);
      return;
    }

    const products = config.products || {};

    const state = {
      gloveClass: null,
      gloveBrand: null,
      cuff: null,
      length: null,
      gloveProductKey: null,
      gloveVariantId: null,

      protectorAdded: false,
      protectorVariantId: null,

      bagAdded: false,
      bagProductKey: null,
      bagVariantId: null,

      testingAdded: false,

      sleevesAdded: false,
      sleeveClass: null,
      sleeveProductKey: null,
      sleeveVariantId: null,

      strapProductKey: null,
      strapVariantId: null,

      quantity: 1
    };

    const els = {
      glovePanel: root.querySelector('[data-step-panel="glove"]'),
      addonsPanel: root.querySelector('[data-step-panel="addons"]'),
      sleevesPanel: root.querySelector('[data-step-panel="sleeves"]'),

      classOptions: root.querySelector('[data-class-options]'),
      brandOptions: root.querySelector('[data-brand-options]'),

      cuffGroup: root.querySelector('[data-cuff-group]'),
      cuffOptions: root.querySelector('[data-cuff-options]'),

      lengthGroup: root.querySelector('[data-length-group]'),
      lengthOptions: root.querySelector('[data-length-options]'),

      sizeGroup: root.querySelector('[data-size-group]'),
      sizeOptions: root.querySelector('[data-size-options]'),

      gloveSelected: root.querySelector('[data-glove-selected]'),
      gloveSelectedImage: root.querySelector(
        '[data-glove-selected-image]'
      ),
      gloveSelectedTitle: root.querySelector(
        '[data-glove-selected-title]'
      ),
      gloveSelectedSku: root.querySelector(
        '[data-glove-selected-sku]'
      ),
      gloveSelectedPrice: root.querySelector(
        '[data-glove-selected-price]'
      ),
      gloveSelectedAvailability: root.querySelector(
        '[data-glove-selected-availability]'
      ),

      protectorAddon: root.querySelector('[data-addon="protector"]'),
      protectorToggle: root.querySelector(
        '[data-addon-toggle="protector"]'
      ),
      protectorImage: root.querySelector(
        '[data-addon-image="protector"]'
      ),
      protectorTitle: root.querySelector(
        '[data-addon-title="protector"]'
      ),
      protectorNote: root.querySelector(
        '[data-addon-note="protector"]'
      ),
      protectorPrice: root.querySelector(
        '[data-addon-price="protector"]'
      ),
      protectorAvailability: root.querySelector(
        '[data-addon-availability="protector"]'
      ),
      protectorVariantWrap: root.querySelector(
        '[data-addon-variant-wrap="protector"]'
      ),
      protectorVariant: root.querySelector(
        '[data-addon-variant="protector"]'
      ),

      bagAddon: root.querySelector('[data-addon="bag"]'),
      bagToggle: root.querySelector('[data-addon-toggle="bag"]'),
      bagImage: root.querySelector('[data-addon-image="bag"]'),
      bagTitle: root.querySelector('[data-addon-title="bag"]'),
      bagPrice: root.querySelector('[data-addon-price="bag"]'),
      bagAvailability: root.querySelector(
        '[data-addon-availability="bag"]'
      ),

      testingAddon: root.querySelector('[data-addon="testing"]'),
      testingToggle: root.querySelector(
        '[data-addon-toggle="testing"]'
      ),
      testingPrice: root.querySelector(
        '[data-addon-price="testing"]'
      ),

      sleevesAddon: root.querySelector('[data-addon="sleeves"]'),
      sleevesToggle: root.querySelector(
        '[data-addon-toggle="sleeves"]'
      ),
      sleevesAddonImage: root.querySelector(
        '[data-addon-image="sleeves"]'
      ),
      sleevesAddonAvailability: root.querySelector(
        '[data-addon-availability="sleeves"]'
      ),

      sleeveClassOptions: root.querySelector(
        '[data-sleeve-class-options]'
      ),
      sleeveSizeGroup: root.querySelector(
        '[data-sleeve-size-group]'
      ),
      sleeveSizeOptions: root.querySelector(
        '[data-sleeve-size-options]'
      ),

      sleeveSelected: root.querySelector('[data-sleeve-selected]'),
      sleeveSelectedImage: root.querySelector(
        '[data-sleeve-selected-image]'
      ),
      sleeveSelectedTitle: root.querySelector(
        '[data-sleeve-selected-title]'
      ),
      sleeveSelectedSku: root.querySelector(
        '[data-sleeve-selected-sku]'
      ),
      sleeveSelectedPrice: root.querySelector(
        '[data-sleeve-selected-price]'
      ),
      sleeveSelectedAvailability: root.querySelector(
        '[data-sleeve-selected-availability]'
      ),

      strapGroup: root.querySelector(
        '[data-sleeve-strap-group]'
      ),
      strapOptions: root.querySelector(
        '[data-sleeve-strap-options]'
      ),

      sleeveBagGroup: root.querySelector(
        '[data-sleeve-bag-group]'
      ),
      sleeveBagOptions: root.querySelector(
        '[data-sleeve-bag-options]'
      ),
      sleeveBagMessage: root.querySelector(
        '[data-sleeve-bag-message]'
      ),

      summaryPreview: root.querySelector(
        '[data-summary-preview]'
      ),
      summaryHeading: root.querySelector(
        '[data-summary-heading]'
      ),
      summaryLines: root.querySelector('[data-summary-lines]'),

      quantityWrap: root.querySelector('[data-quantity-wrap]'),
      quantityInput: root.querySelector('[data-quantity]'),
      qtyMinus: root.querySelector('[data-qty-minus]'),
      qtyPlus: root.querySelector('[data-qty-plus]'),

      totalWrap: root.querySelector('[data-total-wrap]'),
      total: root.querySelector('[data-total]'),

      actions: root.querySelector('[data-actions]'),
      addToCart: root.querySelector('[data-add-to-cart]'),
      addButtonLabel: root.querySelector(
        '[data-add-button-label]'
      ),
      addSpinner: root.querySelector('[data-add-spinner]'),
      requestQuote: root.querySelector('[data-request-quote]'),

      status: root.querySelector('[data-status]')
    };

    const gloveMap = {
      '0': {
        Salisbury: {
          Bell: {
            '11': 'c0_salisbury'
          }
        }
      },

      '1': {
        Salisbury: {
          Bell: {
            '14': 'c1_salisbury'
          }
        }
      },

      '2': {
        NOVAX: {
          Bell: {
            '16': 'c2_novax_16_bell'
          }
        },

        Salisbury: {
          Bell: {
            '16': 'c2_salisbury_16_bell',
            '18': 'c2_salisbury_18_bell'
          },

          Contour: {
            '18': 'c2_salisbury_18_contour'
          }
        }
      },

      '3': {
        NOVAX: {
          Bell: {
            '16': 'c3_novax_16_bell'
          }
        },

        Salisbury: {
          Bell: {
            '16': 'c3_salisbury_16_bell',
            '18': 'c3_salisbury_18_bell'
          },

          Contour: {
            '18': 'c3_salisbury_18_contour'
          }
        }
      }
    };

    const sleeveMap = {
      '2': 'sleeve_c2_novax',
      '3': 'sleeve_c3_novax'
    };

    const strapProductKeys = [
      'sleeve_strap_1',
      'sleeve_strap_2',
      'sleeve_strap_3'
    ];

    function money(cents) {
      const amount = Number(cents || 0) / 100;

      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: config.currency || 'USD'
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    }

    function getProduct(key) {
      const product = products[key];

      if (!product || !product.variants) {
        return null;
      }

      return product;
    }

    function getVariant(productKey, variantId) {
      const product = getProduct(productKey);

      if (!product) return null;

      return (
        product.variants.find(
          (variant) =>
            String(variant.id) === String(variantId)
        ) || null
      );
    }

    function firstAvailableVariant(productKey) {
      const product = getProduct(productKey);

      if (!product) return null;

      return (
        product.variants.find(
          (variant) => variant.available
        ) ||
        product.variants[0] ||
        null
      );
    }

    function productHasAvailableVariant(productKey) {
      const product = getProduct(productKey);

      if (!product) return false;

      return product.variants.some(
        (variant) => variant.available
      );
    }

    function escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    function variantAvailability(
      variant,
      compact = false
    ) {
      if (!variant) return '';

      const stock =
        variant.titanStock === null ||
        variant.titanStock === undefined
          ? null
          : Number(variant.titanStock);

      if (
        stock !== null &&
        Number.isFinite(stock)
      ) {
        if (stock > 0) {
          return compact
            ? `${stock} in stock`
            : `${stock} in stock — usually ships in 1–2 business days.`;
        }

        if (variant.available) {
          return compact
            ? 'Available to order'
            : 'Available to order — contact us for current lead time.';
        }
      }

      if (!variant.available) {
        return 'Unavailable';
      }

      return compact
        ? 'Available'
        : 'Available to order — contact us for current lead time.';
    }

    function createChoice({
      label,
      sublabel = '',
      value,
      selected = false,
      disabled = false,
      logo = null,
      image = null,
      recommended = false
    }) {
      const button =
        document.createElement('button');

      button.type = 'button';
      button.className = 'titan-rgb__choice';
      button.dataset.value = value;
      button.disabled = disabled;

      if (selected) {
        button.classList.add('is-selected');
      }

      let visual = '';

      if (logo) {
        visual = `
          <span class="titan-rgb__choice-logo">
            <img
              src="${escapeHtml(logo)}"
              alt=""
              loading="lazy"
            >
          </span>
        `;
      } else if (image) {
        visual = `
          <span class="titan-rgb__choice-image">
            <img
              src="${escapeHtml(image)}"
              alt=""
              loading="lazy"
            >
          </span>
        `;
      }

      button.innerHTML = `
        ${visual}

        <span class="titan-rgb__choice-copy">
          <strong>${escapeHtml(label)}</strong>

          ${
            sublabel
              ? `<small>${escapeHtml(
                  sublabel
                )}</small>`
              : ''
          }

          ${
            recommended
              ? '<span class="titan-rgb__badge">Titan Recommended</span>'
              : ''
          }
        </span>
      `;

      return button;
    }

    function variantSizeLabel(variant) {
      if (!variant) return '';

      if (
        variant.option1 &&
        variant.option1 !== 'Default Title'
      ) {
        return variant.option1;
      }

      return variant.title || '';
    }

    function baseBagProductKey() {
      if (state.gloveClass === '0') {
        return 'bag_2210';
      }

      return 'bag_2226';
    }

    function resetAddons() {
      state.protectorAdded = false;
      state.protectorVariantId = null;

      state.bagAdded = false;
      state.bagProductKey = null;
      state.bagVariantId = null;

      state.testingAdded = false;

      state.sleevesAdded = false;
      state.sleeveClass = null;
      state.sleeveProductKey = null;
      state.sleeveVariantId = null;

      state.strapProductKey = null;
      state.strapVariantId = null;

      if (els.protectorToggle) {
        els.protectorToggle.checked = false;
      }

      if (els.bagToggle) {
        els.bagToggle.checked = false;
      }

      if (els.testingToggle) {
        els.testingToggle.checked = false;
      }

      if (els.sleevesToggle) {
        els.sleevesToggle.checked = false;
      }

      els.sleevesPanel.hidden = true;
    }

    function resetAfterClass() {
      state.gloveBrand = null;
      state.cuff = null;
      state.length = null;
      state.gloveProductKey = null;
      state.gloveVariantId = null;

      resetAddons();
    }

    function resetAfterBrand() {
      state.cuff = null;
      state.length = null;
      state.gloveProductKey = null;
      state.gloveVariantId = null;

      resetAddons();
    }

    function resetAfterCuff() {
      state.length = null;
      state.gloveProductKey = null;
      state.gloveVariantId = null;

      resetAddons();
    }

    function renderClasses() {
      els.classOptions.innerHTML = '';

      ['0', '1', '2', '3'].forEach(
        (gloveClass) => {
          const classProducts =
            gloveMap[gloveClass] || {};

          const hasConfiguredProduct =
            Object.values(
              classProducts
            ).some((brand) =>
              Object.values(brand).some(
                (cuff) =>
                  Object.values(cuff).some(
                    (key) =>
                      productHasAvailableVariant(
                        key
                      )
                  )
              )
            );

          const button = createChoice({
            label: `Class ${gloveClass}`,
            value: gloveClass,
            selected:
              state.gloveClass ===
              gloveClass,
            disabled:
              !hasConfiguredProduct
          });

          button.addEventListener(
            'click',
            () => {
              if (
                state.gloveClass ===
                gloveClass
              ) {
                return;
              }

              state.gloveClass =
                gloveClass;

              resetAfterClass();
              renderAll();
            }
          );

          els.classOptions.appendChild(
            button
          );
        }
      );
    }

    function renderBrands() {
      if (!state.gloveClass) {
        els.glovePanel.hidden = true;
        return;
      }

      els.glovePanel.hidden = false;
      els.brandOptions.innerHTML = '';

      const classMap =
        gloveMap[state.gloveClass] || {};

      ['NOVAX', 'Salisbury'].forEach(
        (brand) => {
          const brandMap =
            classMap[brand];

          if (!brandMap) return;

          const productKeys =
            Object.values(
              brandMap
            ).flatMap((cuff) =>
              Object.values(cuff)
            );

          if (
            !productKeys.some(
              productHasAvailableVariant
            )
          ) {
            return;
          }

          const logo =
            brand === 'NOVAX'
              ? config.brandLogos?.novax
              : config.brandLogos
                  ?.salisbury;

          /*
           * No Titan Recommended badge on
           * rubber glove brands.
           */
          const button = createChoice({
            label: brand,
            value: brand,
            logo,
            selected:
              state.gloveBrand === brand
          });

          button.addEventListener(
            'click',
            () => {
              if (
                state.gloveBrand ===
                brand
              ) {
                return;
              }

              state.gloveBrand = brand;

              resetAfterBrand();
              renderAll();
            }
          );

          els.brandOptions.appendChild(
            button
          );
        }
      );
    }

    function renderCuffs() {
      if (!state.gloveBrand) {
        els.cuffGroup.hidden = true;
        return;
      }

      const brandMap =
        gloveMap[
          state.gloveClass
        ]?.[state.gloveBrand];

      if (!brandMap) {
        els.cuffGroup.hidden = true;
        return;
      }

      const cuffs =
        Object.keys(brandMap).filter(
          (cuff) =>
            Object.values(
              brandMap[cuff]
            ).some(
              productHasAvailableVariant
            )
        );

      if (!cuffs.length) {
        els.cuffGroup.hidden = true;
        return;
      }

      if (cuffs.length === 1) {
        state.cuff = cuffs[0];
        els.cuffGroup.hidden = true;
        return;
      }

      els.cuffGroup.hidden = false;
      els.cuffOptions.innerHTML = '';

      cuffs.forEach((cuff) => {
        const button = createChoice({
          label: `${cuff} Cuff`,
          value: cuff,
          selected:
            state.cuff === cuff
        });

        button.addEventListener(
          'click',
          () => {
            if (state.cuff === cuff) {
              return;
            }

            state.cuff = cuff;

            resetAfterCuff();
            renderAll();
          }
        );

        els.cuffOptions.appendChild(
          button
        );
      });
    }

    function renderLengths() {
      if (
        !state.gloveBrand ||
        !state.cuff
      ) {
        els.lengthGroup.hidden = true;
        return;
      }

      const cuffMap =
        gloveMap[
          state.gloveClass
        ]?.[state.gloveBrand]?.[
          state.cuff
        ];

      if (!cuffMap) {
        els.lengthGroup.hidden = true;
        return;
      }

      const lengths =
        Object.keys(cuffMap).filter(
          (length) =>
            productHasAvailableVariant(
              cuffMap[length]
            )
        );

      if (!lengths.length) {
        els.lengthGroup.hidden = true;
        return;
      }

      if (lengths.length === 1) {
        state.length = lengths[0];
        state.gloveProductKey =
          cuffMap[lengths[0]];

        els.lengthGroup.hidden = true;
        return;
      }

      els.lengthGroup.hidden = false;
      els.lengthOptions.innerHTML = '';

      lengths.forEach((length) => {
        const productKey =
          cuffMap[length];

        const product =
          getProduct(productKey);

        const button = createChoice({
          label: `${length}"`,
          value: length,
          image:
            product?.featuredImage ||
            null,
          selected:
            state.length === length
        });

        button.addEventListener(
          'click',
          () => {
            state.length = length;
            state.gloveProductKey =
              productKey;
            state.gloveVariantId =
              null;

            resetAddons();
            renderAll();
          }
        );

        els.lengthOptions.appendChild(
          button
        );
      });
    }

    function resolveGloveProduct() {
      if (
        !state.gloveClass ||
        !state.gloveBrand ||
        !state.cuff ||
        !state.length
      ) {
        state.gloveProductKey = null;
        return;
      }

      state.gloveProductKey =
        gloveMap[
          state.gloveClass
        ]?.[state.gloveBrand]?.[
          state.cuff
        ]?.[state.length] || null;
    }

    function renderGloveSizes() {
      resolveGloveProduct();

      const product =
        getProduct(
          state.gloveProductKey
        );

      if (!product) {
        els.sizeGroup.hidden = true;
        els.gloveSelected.hidden =
          true;
        return;
      }

      els.sizeGroup.hidden = false;
      els.sizeOptions.innerHTML = '';

      product.variants.forEach(
        (variant) => {
          const button =
            document.createElement(
              'button'
            );

          button.type = 'button';
          button.className =
            'titan-rgb__size-button';

          if (
            String(
              state.gloveVariantId
            ) ===
            String(variant.id)
          ) {
            button.classList.add(
              'is-selected'
            );
          }

          button.disabled =
            !variant.available;

          const availability =
            variantAvailability(
              variant,
              true
            );

          button.innerHTML = `
            ${escapeHtml(
              variantSizeLabel(variant)
            )}
            ${
              availability
                ? `<small>${escapeHtml(
                    availability
                  )}</small>`
                : ''
            }
          `;

          button.addEventListener(
            'click',
            () => {
              state.gloveVariantId =
                variant.id;

              resetAddons();
              renderAll();
            }
          );

          els.sizeOptions.appendChild(
            button
          );
        }
      );

      renderSelectedGlove();
    }

    function renderSelectedGlove() {
      const product =
        getProduct(
          state.gloveProductKey
        );

      const variant = getVariant(
        state.gloveProductKey,
        state.gloveVariantId
      );

      if (!product || !variant) {
        els.gloveSelected.hidden =
          true;
        return;
      }

      els.gloveSelected.hidden = false;

      els.gloveSelectedImage.src =
        variant.image ||
        product.featuredImage ||
        '';

      els.gloveSelectedImage.alt =
        product.title;

      els.gloveSelectedTitle.textContent =
        product.title;

      els.gloveSelectedSku.textContent =
        variant.sku
          ? `SKU: ${variant.sku}`
          : '';

      els.gloveSelectedPrice.textContent =
        money(variant.price);

      if (
        els.gloveSelectedAvailability
      ) {
        els.gloveSelectedAvailability.textContent =
          variantAvailability(
            variant
          );
      }
    }
function protectorSizeSuffix() {
  const glove = selectedGlove();

  if (!glove) return null;

  const size = String(
    variantSizeLabel(glove.variant)
  )
    .trim()
    .replace('½', '.5');

  if (size === '8' || size === '8.5') {
    return '08';
  }

  if (size === '9' || size === '9.5') {
    return '09';
  }

  if (size === '10' || size === '10.5') {
    return '10';
  }

  if (size === '11' || size === '11.5') {
    return '11';
  }

  return null;
}

function matchingProtectorVariant(product) {
  if (!product) return null;

  const suffix = protectorSizeSuffix();

  if (!suffix) return null;

  return (
    product.variants.find((variant) => {
      const sku = String(
        variant.sku || ''
      ).trim();

      return (
        variant.available &&
        sku.endsWith(suffix)
      );
    }) || null
  );
}
    function protectorProductKey() {
      if (state.gloveClass === '0') {
        return 'protector_c0_10';
      }

      if (state.gloveClass === '1') {
        return 'protector_13';
      }

      if (state.gloveClass === '2') {
        return 'protector_14';
      }

      if (
        state.gloveClass === '3' &&
        state.length === '16'
      ) {
        return 'protector_13';
      }

      if (
        state.gloveClass === '3' &&
        state.length === '18'
      ) {
        return 'protector_14';
      }

      return null;
    }

    function protectorDescription() {
      if (state.gloveClass === '0') {
        return 'Recommended 10" Youngstown secondary protector for this Class 0 configuration.';
      }

      if (state.gloveClass === '1') {
        return 'Recommended 13" Youngstown protector for this Class 1 configuration.';
      }

      if (state.gloveClass === '2') {
        return 'Recommended 14" Youngstown protector for this Class 2 configuration.';
      }

      if (
        state.gloveClass === '3' &&
        state.length === '16'
      ) {
        return 'Recommended 13" Youngstown protector for this 16" Class 3 configuration.';
      }

      if (
        state.gloveClass === '3' &&
        state.length === '18'
      ) {
        return 'Recommended 14" Youngstown protector for this 18" Class 3 configuration.';
      }

      return '';
    }

    function renderProtector() {
      const productKey =
        protectorProductKey();

      const product =
        getProduct(productKey);

      if (!product) {
        els.protectorAddon.hidden = true;
        state.protectorAdded = false;
        state.protectorVariantId = null;

        if (els.protectorToggle) {
          els.protectorToggle.checked = false;
          els.protectorToggle.disabled = true;
        }

        return;
      }

      els.protectorAddon.hidden = false;
      els.protectorTitle.textContent = product.title;

      if (product.featuredImage) {
        els.protectorImage.src = product.featuredImage;
        els.protectorImage.alt = product.title;
      }

      /*
       * Titan automatically matches protector size
       * to the selected rubber glove size.
       * The customer does not choose a protector variant.
       */
      const matchedProtector =
        matchingProtectorVariant(product);

      els.protectorVariantWrap.hidden = true;

      if (!matchedProtector) {
        state.protectorVariantId = null;
        state.protectorAdded = false;

        if (els.protectorToggle) {
          els.protectorToggle.checked = false;
          els.protectorToggle.disabled = true;
        }

        els.protectorPrice.textContent = '';

        const glove = selectedGlove();
        const gloveSize = glove
          ? variantSizeLabel(glove.variant)
          : '';

        els.protectorNote.textContent = gloveSize
          ? `${protectorDescription()} No automatic protector size has been configured for glove size ${gloveSize}.`
          : protectorDescription();

        if (els.protectorAvailability) {
          els.protectorAvailability.textContent =
            'Compatible protector size not configured.';
        }

        els.protectorAddon.classList.remove('is-selected');
        return;
      }

      if (els.protectorToggle) {
        els.protectorToggle.disabled = false;
      }

      state.protectorVariantId =
        matchedProtector.id;

      els.protectorNote.textContent =
        `${protectorDescription()} ${matchedProtector.title} is matched automatically to your selected glove size.`;

      els.protectorPrice.textContent =
        money(matchedProtector.price);

      if (els.protectorAvailability) {
        els.protectorAvailability.textContent =
          variantAvailability(matchedProtector);
      }

      els.protectorToggle.checked =
        state.protectorAdded;

      els.protectorAddon.classList.toggle(
        'is-selected',
        state.protectorAdded
      );
    }

    function renderBag() {
      const recommendedKey =
        baseBagProductKey();

      const displayKey =
        state.bagAdded
          ? state.bagProductKey ||
            recommendedKey
          : recommendedKey;

      const product =
        getProduct(displayKey);

      if (!product) {
        els.bagAddon.hidden = true;
        state.bagAdded = false;
        state.bagProductKey = null;
        state.bagVariantId = null;
        return;
      }

      const variant =
        firstAvailableVariant(
          displayKey
        );

      if (!variant) {
        els.bagAddon.hidden = true;
        return;
      }

      if (state.bagAdded) {
        state.bagProductKey =
          displayKey;

        state.bagVariantId =
          variant.id;
      }

      els.bagAddon.hidden = false;
      els.bagTitle.textContent =
        product.title;
      els.bagPrice.textContent =
        money(variant.price);

      if (product.featuredImage) {
        els.bagImage.src =
          product.featuredImage;
        els.bagImage.alt =
          product.title;
      }

      if (els.bagAvailability) {
        els.bagAvailability.textContent =
          variantAvailability(variant);
      }

      els.bagToggle.checked =
        state.bagAdded;

      els.bagAddon.classList.toggle(
        'is-selected',
        state.bagAdded
      );
    }

    function renderSleeveAddon() {
      const allowed =
        ['2', '3'].includes(
          state.gloveClass
        );

      const productKey =
        sleeveMap[state.gloveClass];

      const product =
        getProduct(productKey);

      if (
        !allowed ||
        !productKey ||
        !productHasAvailableVariant(
          productKey
        )
      ) {
        els.sleevesAddon.hidden =
          true;

        state.sleevesAdded = false;
        state.sleeveClass = null;
        state.sleeveProductKey =
          null;
        state.sleeveVariantId = null;
        state.strapProductKey = null;
        state.strapVariantId = null;

        els.sleevesPanel.hidden =
          true;

        return;
      }

      els.sleevesAddon.hidden = false;

      els.sleevesToggle.checked =
        state.sleevesAdded;

      els.sleevesAddon.classList.toggle(
        'is-selected',
        state.sleevesAdded
      );

      /*
       * Replace the generic S icon
       * with the actual NOVAX sleeve image.
       */
      if (
        els.sleevesAddonImage &&
        product.featuredImage
      ) {
        els.sleevesAddonImage.src =
          product.featuredImage;

        els.sleevesAddonImage.alt =
          product.title;
      }

      const variant =
        firstAvailableVariant(
          productKey
        );

      if (
        els.sleevesAddonAvailability
      ) {
        els.sleevesAddonAvailability.textContent =
          variant
            ? variantAvailability(
                variant
              )
            : '';
      }
    }

    function renderTesting() {
      const gloveProduct =
        getProduct(
          state.gloveProductKey
        );

      const gloveTesting =
        gloveProduct?.testing || null;

      let sleeveTesting = null;

      if (
        state.sleevesAdded &&
        state.sleeveProductKey
      ) {
        sleeveTesting =
          getProduct(
            state.sleeveProductKey
          )?.testing || null;
      }

      if (
        !gloveTesting &&
        !sleeveTesting
      ) {
        els.testingAddon.hidden =
          true;
        state.testingAdded = false;
        return;
      }

      els.testingAddon.hidden = false;

      let testingTotal = 0;

      if (gloveTesting) {
        testingTotal += Number(
          gloveTesting.price || 0
        );
      }

      if (sleeveTesting) {
        testingTotal += Number(
          sleeveTesting.price || 0
        );
      }

      els.testingPrice.textContent =
        testingTotal
          ? `${money(
              testingTotal
            )} per setup`
          : '';

      els.testingToggle.checked =
        state.testingAdded;

      els.testingAddon.classList.toggle(
        'is-selected',
        state.testingAdded
      );
    }

    function renderAddons() {
      const gloveVariant =
        getVariant(
          state.gloveProductKey,
          state.gloveVariantId
        );

      if (!gloveVariant) {
        els.addonsPanel.hidden = true;
        return;
      }

      els.addonsPanel.hidden = false;

      renderProtector();
      renderSleeveAddon();
      renderBag();
      renderTesting();
    }

    function renderSleeveClasses() {
      if (!state.sleevesAdded) {
        return;
      }

      els.sleeveClassOptions.innerHTML =
        '';

      ['2', '3'].forEach(
        (sleeveClass) => {
          const productKey =
            sleeveMap[sleeveClass];

          if (
            !productKey ||
            !productHasAvailableVariant(
              productKey
            )
          ) {
            return;
          }

          const button = createChoice({
            label: `Class ${sleeveClass}`,
            sublabel:
              sleeveClass ===
              state.gloveClass
                ? 'Matches selected glove class'
                : '',
            value: sleeveClass,
            selected:
              state.sleeveClass ===
              sleeveClass
          });

          button.addEventListener(
            'click',
            () => {
              if (
                state.sleeveClass ===
                sleeveClass
              ) {
                return;
              }

              state.sleeveClass =
                sleeveClass;

              state.sleeveProductKey =
                null;

              state.sleeveVariantId =
                null;

              state.strapProductKey =
                null;

              state.strapVariantId =
                null;

              renderAll();
            }
          );

          els.sleeveClassOptions.appendChild(
            button
          );
        }
      );
    }

    function resolveSleeveProduct() {
      state.sleeveProductKey =
        state.sleeveClass
          ? sleeveMap[
              state.sleeveClass
            ] || null
          : null;
    }

    function renderSleeveSizes() {
      resolveSleeveProduct();

      const product =
        getProduct(
          state.sleeveProductKey
        );

      if (!product) {
        els.sleeveSizeGroup.hidden =
          true;

        els.sleeveSelected.hidden =
          true;

        return;
      }

      els.sleeveSizeGroup.hidden =
        false;

      els.sleeveSizeOptions.innerHTML =
        '';

      product.variants.forEach(
        (variant) => {
          const button =
            document.createElement(
              'button'
            );

          button.type = 'button';

          button.className =
            'titan-rgb__size-button';

          button.disabled =
            !variant.available;

          if (
            String(
              state.sleeveVariantId
            ) ===
            String(variant.id)
          ) {
            button.classList.add(
              'is-selected'
            );
          }

          const availability =
            variantAvailability(
              variant,
              true
            );

          button.innerHTML = `
            ${escapeHtml(
              variantSizeLabel(variant)
            )}
            ${
              availability
                ? `<small>${escapeHtml(
                    availability
                  )}</small>`
                : ''
            }
          `;

          button.addEventListener(
            'click',
            () => {
              state.sleeveVariantId =
                variant.id;

              state.strapProductKey =
                null;

              state.strapVariantId =
                null;

              renderAll();
            }
          );

          els.sleeveSizeOptions.appendChild(
            button
          );
        }
      );

      renderSelectedSleeves();
    }

    function renderSelectedSleeves() {
      const product =
        getProduct(
          state.sleeveProductKey
        );

      const variant =
        getVariant(
          state.sleeveProductKey,
          state.sleeveVariantId
        );

      if (!product || !variant) {
        els.sleeveSelected.hidden =
          true;
        return;
      }

      els.sleeveSelected.hidden = false;

      els.sleeveSelectedImage.src =
        variant.image ||
        product.featuredImage ||
        '';

      els.sleeveSelectedImage.alt =
        product.title;

      els.sleeveSelectedTitle.textContent =
        product.title;

      els.sleeveSelectedSku.textContent =
        variant.sku
          ? `SKU: ${variant.sku}`
          : '';

      els.sleeveSelectedPrice.textContent =
        money(variant.price);

      if (
        els.sleeveSelectedAvailability
      ) {
        els.sleeveSelectedAvailability.textContent =
          variantAvailability(
            variant
          );
      }
    }

    function renderStraps() {
      if (
        !state.sleevesAdded ||
        !state.sleeveVariantId
      ) {
        els.strapGroup.hidden = true;

        state.strapProductKey = null;
        state.strapVariantId = null;

        return;
      }

      const configured =
        strapProductKeys.filter(
          (key) =>
            productHasAvailableVariant(
              key
            )
        );

      if (!configured.length) {
        els.strapGroup.hidden = true;
        return;
      }

      els.strapGroup.hidden = false;
      els.strapOptions.innerHTML = '';

      const none = createChoice({
        label: 'Do Not Include',
        sublabel:
          'Sleeve straps are optional',
        value: 'none',
        selected:
          !state.strapProductKey
      });

      none.addEventListener(
        'click',
        () => {
          state.strapProductKey = null;
          state.strapVariantId = null;

          renderAll();
        }
      );

      els.strapOptions.appendChild(
        none
      );

      configured.forEach(
        (productKey) => {
          const product =
            getProduct(productKey);

          const variant =
            firstAvailableVariant(
              productKey
            );

          if (!product || !variant) {
            return;
          }

          const availability =
            variantAvailability(
              variant,
              true
            );

          const button = createChoice({
            label: product.title,
            sublabel: `${money(
              variant.price
            )}${
              availability
                ? ` • ${availability}`
                : ''
            }`,
            value: productKey,
            image:
              variant.image ||
              product.featuredImage ||
              null,
            selected:
              state.strapProductKey ===
              productKey
          });

          button.addEventListener(
            'click',
            () => {
              state.strapProductKey =
                productKey;

              state.strapVariantId =
                variant.id;

              renderAll();
            }
          );

          els.strapOptions.appendChild(
            button
          );
        }
      );
    }

    function renderSleeveBagChoice() {
      if (
        !state.sleevesAdded ||
        !state.sleeveVariantId
      ) {
        els.sleeveBagGroup.hidden =
          true;
        return;
      }

      const gloveBag =
        getProduct('bag_2226');

      const comboBag =
        getProduct('bag_2449');

      const gloveBagVariant =
        firstAvailableVariant(
          'bag_2226'
        );

      const comboBagVariant =
        firstAvailableVariant(
          'bag_2449'
        );

      if (
        !gloveBag &&
        !comboBag
      ) {
        els.sleeveBagGroup.hidden =
          true;
        return;
      }

      els.sleeveBagGroup.hidden = false;
      els.sleeveBagOptions.innerHTML = '';

      if (
        state.bagAdded &&
        state.bagProductKey ===
          'bag_2226'
      ) {
        els.sleeveBagMessage.textContent =
          'You already selected the Estex 2226-R66 glove bag. Keep it, switch to the larger glove-and-sleeve bag, or remove the bag.';
      } else if (
        state.bagAdded &&
        state.bagProductKey ===
          'bag_2449'
      ) {
        els.sleeveBagMessage.textContent =
          'You currently have the larger Estex glove-and-sleeve bag selected. You can keep it, switch back to the glove-only bag, or remove the bag.';
      } else {
        els.sleeveBagMessage.textContent =
          'Storage is optional. Choose no bag, the glove-only Estex 2226-R66, or the larger Estex 2449-TU-CR66 for gloves and sleeves.';
      }

      const none = createChoice({
        label: 'Do Not Include a Bag',
        sublabel:
          'Gloves and sleeves only',
        value: 'none',
        selected: !state.bagAdded
      });

      none.addEventListener(
        'click',
        () => {
          state.bagAdded = false;
          state.bagProductKey = null;
          state.bagVariantId = null;

          renderAll();
        }
      );

      els.sleeveBagOptions.appendChild(
        none
      );

      if (
        gloveBag &&
        gloveBagVariant
      ) {
        const availability =
          variantAvailability(
            gloveBagVariant,
            true
          );

        const button = createChoice({
          label: gloveBag.title,
          sublabel: `${money(
            gloveBagVariant.price
          )}${
            availability
              ? ` • ${availability}`
              : ''
          }`,
          value: 'bag_2226',
          image:
            gloveBagVariant.image ||
            gloveBag.featuredImage ||
            null,
          selected:
            state.bagAdded &&
            state.bagProductKey ===
              'bag_2226'
        });

        button.addEventListener(
          'click',
          () => {
            state.bagAdded = true;
            state.bagProductKey =
              'bag_2226';

            state.bagVariantId =
              gloveBagVariant.id;

            renderAll();
          }
        );

        els.sleeveBagOptions.appendChild(
          button
        );
      }

      if (
        comboBag &&
        comboBagVariant
      ) {
        const availability =
          variantAvailability(
            comboBagVariant,
            true
          );

        const button = createChoice({
          label: comboBag.title,
          sublabel: `${money(
            comboBagVariant.price
          )}${
            availability
              ? ` • ${availability}`
              : ''
          }`,
          value: 'bag_2449',
          image:
            comboBagVariant.image ||
            comboBag.featuredImage ||
            null,
          selected:
            state.bagAdded &&
            state.bagProductKey ===
              'bag_2449'
        });

        button.addEventListener(
          'click',
          () => {
            state.bagAdded = true;
            state.bagProductKey =
              'bag_2449';

            state.bagVariantId =
              comboBagVariant.id;

            renderAll();
          }
        );

        els.sleeveBagOptions.appendChild(
          button
        );
      }
    }

    function renderSleeves() {
      if (!state.sleevesAdded) {
        els.sleevesPanel.hidden = true;
        return;
      }

      els.sleevesPanel.hidden = false;

      if (!state.sleeveClass) {
        state.sleeveClass =
          ['2', '3'].includes(
            state.gloveClass
          )
            ? state.gloveClass
            : '2';
      }

      renderSleeveClasses();
      renderSleeveSizes();
      renderStraps();
      renderSleeveBagChoice();
    }

    function selectedGlove() {
      const product =
        getProduct(
          state.gloveProductKey
        );

      const variant =
        getVariant(
          state.gloveProductKey,
          state.gloveVariantId
        );

      if (!product || !variant) {
        return null;
      }

      return { product, variant };
    }

    function selectedProtector() {
      if (!state.protectorAdded) {
        return null;
      }

      const productKey =
        protectorProductKey();

      const product =
        getProduct(productKey);

      const variant =
        getVariant(
          productKey,
          state.protectorVariantId
        );

      if (!product || !variant) {
        return null;
      }

      return { product, variant };
    }

    function selectedSleeve() {
      if (!state.sleevesAdded) {
        return null;
      }

      const product =
        getProduct(
          state.sleeveProductKey
        );

      const variant =
        getVariant(
          state.sleeveProductKey,
          state.sleeveVariantId
        );

      if (!product || !variant) {
        return null;
      }

      return { product, variant };
    }

    function selectedStrap() {
      if (
        !state.strapProductKey ||
        !state.strapVariantId
      ) {
        return null;
      }

      const product =
        getProduct(
          state.strapProductKey
        );

      const variant =
        getVariant(
          state.strapProductKey,
          state.strapVariantId
        );

      if (!product || !variant) {
        return null;
      }

      return { product, variant };
    }

    function selectedBag() {
      if (
        !state.bagAdded ||
        !state.bagProductKey
      ) {
        return null;
      }

      const product =
        getProduct(
          state.bagProductKey
        );

      const variant =
        getVariant(
          state.bagProductKey,
          state.bagVariantId
        );

      if (!product || !variant) {
        return null;
      }

      return { product, variant };
    }

    function buildSummaryItems() {
      const items = [];

      const glove =
        selectedGlove();

      if (glove) {
        items.push({
          label: 'Rubber Gloves',
          title: glove.product.title,
          detail:
            glove.variant.sku ||
            glove.variant.title,
          price:
            Number(
              glove.variant.price
            ),
          availability:
            variantAvailability(
              glove.variant,
              true
            )
        });
      }

      const protector =
        selectedProtector();

      if (protector) {
        items.push({
          label: 'Leather Protectors',
          title:
            protector.product.title,
          detail:
            protector.variant.sku ||
            protector.variant.title,
          price:
            Number(
              protector.variant.price
            ),
          availability:
            variantAvailability(
              protector.variant,
              true
            )
        });
      }

      const sleeve =
        selectedSleeve();

      if (sleeve) {
        items.push({
          label: 'NOVAX Rubber Sleeves',
          title:
            sleeve.product.title,
          detail:
            sleeve.variant.sku ||
            sleeve.variant.title,
          price:
            Number(
              sleeve.variant.price
            ),
          availability:
            variantAvailability(
              sleeve.variant,
              true
            )
        });
      }

      const strap =
        selectedStrap();

      if (strap) {
        items.push({
          label: 'Sleeve Straps',
          title: strap.product.title,
          detail:
            strap.variant.sku ||
            strap.variant.title,
          price:
            Number(
              strap.variant.price
            ),
          availability:
            variantAvailability(
              strap.variant,
              true
            )
        });
      }

      const bag =
        selectedBag();

      if (bag) {
        items.push({
          label: 'Estex Storage Bag',
          title: bag.product.title,
          detail:
            bag.variant.sku ||
            bag.variant.title,
          price:
            Number(
              bag.variant.price
            ),
          availability:
            variantAvailability(
              bag.variant,
              true
            )
        });
      }

      if (state.testingAdded) {
        if (
          glove?.product.testing
        ) {
          items.push({
            label: 'Titan Testing',
            title:
              glove.product.testing
                .title ||
              'Dielectric Testing',
            detail: 'Rubber gloves',
            price:
              Number(
                glove.product.testing
                  .price || 0
              ),
            availability: ''
          });
        }

        if (
          sleeve?.product.testing
        ) {
          items.push({
            label: 'Titan Testing',
            title:
              sleeve.product.testing
                .title ||
              'Dielectric Testing',
            detail: 'Rubber sleeves',
            price:
              Number(
                sleeve.product.testing
                  .price || 0
              ),
            availability: ''
          });
        }
      }

      return items;
    }

    function renderSummary() {
      const glove =
        selectedGlove();

      if (!glove) {
        els.summaryPreview.innerHTML = `
          <div class="titan-rgb__summary-placeholder">
            <span>
              Start by selecting your glove configuration.
            </span>
          </div>
        `;

        els.summaryLines.innerHTML = '';
        els.quantityWrap.hidden = true;
        els.totalWrap.hidden = true;
        els.actions.hidden = true;

        return;
      }

      const image =
        glove.variant.image ||
        glove.product.featuredImage;

      if (image) {
        els.summaryPreview.innerHTML = `
          <img
            src="${escapeHtml(image)}"
            alt="${escapeHtml(
              glove.product.title
            )}"
          >
        `;
      }

      els.summaryHeading.textContent =
        state.sleevesAdded
          ? 'Rubber Goods Kit'
          : 'Rubber Glove Kit';

      const items =
        buildSummaryItems();

      els.summaryLines.innerHTML =
        items
          .map(
            (item) => `
              <div class="titan-rgb__summary-line">
                <div>
                  <strong>
                    ${escapeHtml(
                      item.label
                    )}
                  </strong>

                  <small>
                    ${escapeHtml(
                      item.title
                    )}
                    ${
                      item.detail
                        ? ` — ${escapeHtml(
                            item.detail
                          )}`
                        : ''
                    }
                    ${
                      item.availability
                        ? `<br>${escapeHtml(
                            item.availability
                          )}`
                        : ''
                    }
                  </small>
                </div>

                <strong>
                  ${money(item.price)}
                </strong>
              </div>
            `
          )
          .join('');

      const totalPerSetup =
        items.reduce(
          (total, item) =>
            total +
            Number(item.price || 0),
          0
        );

      els.total.textContent =
        money(
          totalPerSetup *
            state.quantity
        );

      els.quantityWrap.hidden = false;
      els.totalWrap.hidden = false;
      els.actions.hidden = false;

      updateQuoteUrl();
    }

    function buildQuoteDescription() {
      const lines = [
        'TITAN RUBBER GLOVE KIT BUILDER CONFIGURATION',
        ''
      ];

      const glove =
        selectedGlove();

      if (glove) {
        lines.push('RUBBER GLOVES');
        lines.push(
          `Brand: ${
            state.gloveBrand || 'N/A'
          }`
        );
        lines.push(
          `Class: Class ${state.gloveClass}`
        );
        lines.push(
          `Cuff: ${
            state.cuff
              ? `${state.cuff} Cuff`
              : 'N/A'
          }`
        );
        lines.push(
          `Length: ${
            state.length
              ? `${state.length} in.`
              : 'N/A'
          }`
        );
        lines.push(
          `Size: ${
            variantSizeLabel(
              glove.variant
            ) || 'N/A'
          }`
        );
        lines.push(
          `Product: ${glove.product.title}`
        );
        lines.push(
          `SKU: ${
            glove.variant.sku || 'N/A'
          }`
        );
        lines.push('');
      }

      const protector =
        selectedProtector();

      lines.push('LEATHER PROTECTORS');

      if (protector) {
        lines.push(
          `Product: ${protector.product.title}`
        );
        lines.push(
          `Option: ${
            protector.variant.title ||
            'N/A'
          }`
        );
        lines.push(
          `SKU: ${
            protector.variant.sku ||
            'N/A'
          }`
        );
      } else {
        lines.push('Do not include');
      }

      lines.push('');

      const sleeve =
        selectedSleeve();

      lines.push('RUBBER SLEEVES');

      if (sleeve) {
        lines.push('Brand: NOVAX');
        lines.push(
          `Class: Class ${state.sleeveClass}`
        );
        lines.push(
          `Size: ${
            variantSizeLabel(
              sleeve.variant
            ) || 'N/A'
          }`
        );
        lines.push(
          `Product: ${sleeve.product.title}`
        );
        lines.push(
          `SKU: ${
            sleeve.variant.sku ||
            'N/A'
          }`
        );
      } else {
        lines.push('Do not include');
      }

      lines.push('');

      const strap =
        selectedStrap();

      lines.push('SLEEVE STRAPS');

      if (strap) {
        lines.push(
          `Product: ${strap.product.title}`
        );
        lines.push(
          `SKU: ${
            strap.variant.sku || 'N/A'
          }`
        );
      } else {
        lines.push('Do not include');
      }

      lines.push('');

      const bag =
        selectedBag();

      lines.push('STORAGE BAG');

      if (bag) {
        lines.push(
          `Product: ${bag.product.title}`
        );
        lines.push(
          `SKU: ${
            bag.variant.sku || 'N/A'
          }`
        );
      } else {
        lines.push('Do not include');
      }

      lines.push('');

      lines.push(
        'TITAN DIELECTRIC TESTING'
      );

      lines.push(
        state.testingAdded
          ? 'Requested'
          : 'Do not include'
      );

      lines.push('');
      lines.push(
        `Quantity of identical setups: ${state.quantity}`
      );

      return lines.join('\n');
    }

    function quoteManufacturer() {
      const manufacturers = [];

      if (state.gloveBrand) {
        manufacturers.push(
          state.gloveBrand
        );
      }

      if (
        selectedSleeve() &&
        !manufacturers.includes(
          'NOVAX'
        )
      ) {
        manufacturers.push('NOVAX');
      }

      return manufacturers.join(' / ');
    }

    function updateQuoteUrl() {
      const glove =
        selectedGlove();

      if (!glove) return;

      const params =
        new URLSearchParams();

      /*
       * Your existing Request a Quote page
       * reads "product" directly into the
       * large Product or Description field.
       */
      params.set(
        'product',
        buildQuoteDescription()
      );

      params.set(
        'manufacturer',
        quoteManufacturer()
      );

      params.set(
        'sku',
        glove.variant.sku || ''
      );

      params.set(
        'quantity',
        String(state.quantity)
      );

      els.requestQuote.href =
        `${config.quoteUrl}?${params.toString()}`;
    }

    function renderAll() {
      renderClasses();
      renderBrands();
      renderCuffs();
      renderLengths();
      renderGloveSizes();

      renderAddons();
      renderSleeves();

      renderBag();
      renderTesting();

      renderSummary();
    }

    function setStatus(
      message,
      isError = false
    ) {
      els.status.textContent = message;
      els.status.hidden = false;

      els.status.classList.toggle(
        'is-error',
        isError
      );
    }

    function clearStatus() {
      els.status.hidden = true;
      els.status.textContent = '';

      els.status.classList.remove(
        'is-error'
      );
    }

    function addCartLine(
      map,
      variantId,
      quantity,
      properties = {}
    ) {
      if (!variantId || quantity < 1) {
        return;
      }

      /*
       * Include properties in the key so
       * glove testing and sleeve testing
       * remain separate cart lines even if
       * they use the same service variant.
       */
      const key =
        `${variantId}|${JSON.stringify(
          properties
        )}`;

      if (!map.has(key)) {
        map.set(key, {
          id: Number(variantId),
          quantity: 0,
          properties
        });
      }

      map.get(key).quantity +=
        quantity;
    }

    async function addSelectedItemsToCart() {
      clearStatus();

      const glove =
        selectedGlove();

      if (!glove) {
        setStatus(
          'Please finish selecting your rubber gloves first.',
          true
        );

        return;
      }

      if (
        state.sleevesAdded &&
        !selectedSleeve()
      ) {
        setStatus(
          'Please finish selecting your NOVAX rubber sleeves or turn sleeves off.',
          true
        );

        return;
      }

      const setupQuantity =
        Math.max(
          1,
          Number(state.quantity) || 1
        );

      const groupId =
        `Titan-Rubber-Goods-${Date.now()}`;

      const baseProperties = {
        'Titan Builder':
          'Rubber Glove Kit',
        'Builder Group':
          groupId
      };

      const cartMap = new Map();

      addCartLine(
        cartMap,
        glove.variant.id,
        setupQuantity,
        {
          ...baseProperties,
          'Glove Class':
            `Class ${state.gloveClass}`,
          'Glove Brand':
            state.gloveBrand || '',
          'Cuff Style':
            state.cuff
              ? `${state.cuff} Cuff`
              : '',
          'Glove Length':
            state.length
              ? `${state.length} in.`
              : '',
          'Glove Size':
            variantSizeLabel(
              glove.variant
            )
        }
      );

      const protector =
        selectedProtector();

      if (protector) {
        addCartLine(
          cartMap,
          protector.variant.id,
          setupQuantity,
          {
            ...baseProperties,
            'Builder Item':
              'Leather Protectors'
          }
        );
      }

      const sleeve =
        selectedSleeve();

      if (sleeve) {
        addCartLine(
          cartMap,
          sleeve.variant.id,
          setupQuantity,
          {
            ...baseProperties,
            'Builder Item':
              'NOVAX Rubber Sleeves',
            'Sleeve Class':
              `Class ${state.sleeveClass}`,
            'Sleeve Size':
              variantSizeLabel(
                sleeve.variant
              )
          }
        );
      }

      const strap =
        selectedStrap();

      if (strap) {
        addCartLine(
          cartMap,
          strap.variant.id,
          setupQuantity,
          {
            ...baseProperties,
            'Builder Item':
              'Sleeve Straps'
          }
        );
      }

      const bag =
        selectedBag();

      if (bag) {
        addCartLine(
          cartMap,
          bag.variant.id,
          setupQuantity,
          {
            ...baseProperties,
            'Builder Item':
              'Estex Storage Bag'
          }
        );
      }

      if (state.testingAdded) {
        if (
          glove.product.testing?.id
        ) {
          addCartLine(
            cartMap,
            glove.product.testing.id,
            setupQuantity,
            {
              ...baseProperties,
              'Testing For':
                'Rubber Gloves'
            }
          );
        }

        if (
          sleeve?.product.testing?.id
        ) {
          addCartLine(
            cartMap,
            sleeve.product.testing.id,
            setupQuantity,
            {
              ...baseProperties,
              'Testing For':
                'Rubber Sleeves'
            }
          );
        }
      }

      const items =
        Array.from(
          cartMap.values()
        );

      if (!items.length) return;

      els.addToCart.disabled = true;
      els.addSpinner.hidden = false;

      els.addButtonLabel.textContent =
        'ADDING...';

      try {
        const rootRoute =
          window.Shopify?.routes
            ?.root || '/';

        const response =
          await fetch(
            `${rootRoute}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Accept:
                  'application/json'
              },
              body: JSON.stringify({
                items
              })
            }
          );

        const result =
          await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
              result.message ||
              'Unable to add this configuration to the cart.'
          );
        }

        setStatus(
          'Your selected rubber goods were added to the cart.'
        );

        document.dispatchEvent(
          new CustomEvent(
            'cart:refresh'
          )
        );

        setTimeout(() => {
          window.location.href =
            `${rootRoute}cart`;
        }, 500);
      } catch (error) {
        console.error(
          'Titan Rubber Glove Builder cart error:',
          error
        );

        setStatus(
          error.message ||
            'Something went wrong while adding the items to the cart.',
          true
        );
      } finally {
        els.addToCart.disabled = false;
        els.addSpinner.hidden = true;

        els.addButtonLabel.textContent =
          'ADD SELECTED ITEMS TO CART';
      }
    }

    els.protectorToggle?.addEventListener(
      'change',
      () => {
        state.protectorAdded =
          els.protectorToggle.checked;

        renderAll();
      }
    );

    els.protectorVariant?.addEventListener(
      'change',
      () => {
        state.protectorVariantId =
          els.protectorVariant.value;

        renderAll();
      }
    );

    els.bagToggle?.addEventListener(
      'change',
      () => {
        state.bagAdded =
          els.bagToggle.checked;

        if (state.bagAdded) {
          state.bagProductKey =
            baseBagProductKey();

          state.bagVariantId =
            firstAvailableVariant(
              state.bagProductKey
            )?.id || null;
        } else {
          state.bagProductKey = null;
          state.bagVariantId = null;
        }

        renderAll();
      }
    );

    els.testingToggle?.addEventListener(
      'change',
      () => {
        state.testingAdded =
          els.testingToggle.checked;

        renderAll();
      }
    );

    els.sleevesToggle?.addEventListener(
      'change',
      () => {
        state.sleevesAdded =
          els.sleevesToggle.checked;

        if (state.sleevesAdded) {
          state.sleeveClass =
            ['2', '3'].includes(
              state.gloveClass
            )
              ? state.gloveClass
              : '2';

          /*
           * Important:
           * Keep any existing 2226-R66
           * selection. Do NOT automatically
           * switch it to the 2449.
           */
        } else {
          state.sleeveClass = null;
          state.sleeveProductKey =
            null;
          state.sleeveVariantId =
            null;

          state.strapProductKey =
            null;
          state.strapVariantId =
            null;

          /*
           * If the customer had deliberately
           * switched to the sleeve bag and
           * then removes sleeves, return the
           * bag recommendation to glove-only.
           */
          if (
            state.bagAdded &&
            state.bagProductKey ===
              'bag_2449'
          ) {
            state.bagProductKey =
              baseBagProductKey();

            state.bagVariantId =
              firstAvailableVariant(
                state.bagProductKey
              )?.id || null;
          }
        }

        renderAll();
      }
    );

    els.qtyMinus?.addEventListener(
      'click',
      () => {
        state.quantity =
          Math.max(
            1,
            state.quantity - 1
          );

        els.quantityInput.value =
          state.quantity;

        renderSummary();
      }
    );

    els.qtyPlus?.addEventListener(
      'click',
      () => {
        state.quantity =
          Math.min(
            99,
            state.quantity + 1
          );

        els.quantityInput.value =
          state.quantity;

        renderSummary();
      }
    );

    els.quantityInput?.addEventListener(
      'change',
      () => {
        const value =
          Number(
            els.quantityInput.value
          );

        state.quantity =
          Math.min(
            99,
            Math.max(
              1,
              Number.isFinite(value)
                ? value
                : 1
            )
          );

        els.quantityInput.value =
          state.quantity;

        renderSummary();
      }
    );

    els.addToCart?.addEventListener(
      'click',
      addSelectedItemsToCart
    );

    renderAll();
  }
})();